export function CourseSkeleton() {
  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6 animate-pulse">
      <div className="flex items-center gap-2 mb-3">
        <div className="h-5 w-12 bg-gray-200 rounded-lg" />
        <div className="h-5 w-20 bg-gray-100 rounded-lg" />
      </div>
      <div className="h-5 w-3/4 bg-gray-200 rounded mb-2" />
      <div className="h-4 w-full bg-gray-100 rounded mb-1" />
      <div className="h-4 w-2/3 bg-gray-100 rounded mb-4" />
      <div className="flex gap-3 mb-3">
        <div className="h-3 w-16 bg-gray-100 rounded" />
        <div className="h-3 w-16 bg-gray-100 rounded" />
      </div>
      <div className="h-4 w-24 bg-gray-200 rounded" />
    </div>
  );
}

export function CourseDetailSkeleton() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="bg-[#0B1D3A] px-6 md:px-12 lg:px-24 py-8 animate-pulse">
        <div className="max-w-7xl mx-auto">
          <div className="h-4 w-28 bg-white/10 rounded mb-5" />
          <div className="flex gap-2 mb-3">
            <div className="h-5 w-10 bg-white/10 rounded-lg" />
            <div className="h-5 w-20 bg-white/10 rounded-lg" />
          </div>
          <div className="h-8 w-2/3 bg-white/10 rounded mb-2" />
          <div className="h-4 w-1/2 bg-white/5 rounded mb-5" />
          <div className="h-2 w-48 bg-white/10 rounded" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-8">
        <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-8">
          <div className="space-y-3">
            {[1,2,3,4].map(i => <div key={i} className="h-10 bg-gray-200 rounded-xl animate-pulse" />)}
          </div>
          <div className="space-y-4">
            <div className="h-6 w-1/2 bg-gray-200 rounded animate-pulse" />
            <div className="h-4 w-full bg-gray-100 rounded animate-pulse" />
            <div className="h-4 w-3/4 bg-gray-100 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-8 animate-pulse">
      <div className="h-8 w-48 bg-gray-200 rounded mb-2" />
      <div className="h-4 w-64 bg-gray-100 rounded mb-8" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {[1,2,3].map(i => <div key={i} className="h-28 bg-gray-200 rounded-2xl" />)}
      </div>
      <div className="h-6 w-32 bg-gray-200 rounded mb-4" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[1,2].map(i => <div key={i} className="h-20 bg-gray-100 rounded-xl" />)}
      </div>
    </div>
  );
}

export function AdminSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[1,2,3,4,5,6,7,8].map(i => <div key={i} className="h-24 bg-white/[0.03] border border-white/[0.06] rounded-2xl" />)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="h-56 bg-white/[0.03] border border-white/[0.06] rounded-2xl" />
        <div className="h-56 bg-white/[0.03] border border-white/[0.06] rounded-2xl" />
      </div>
    </div>
  );
}
